import { RFQListItem } from "@/lib/queries/types";
import NoBidIcon from "~icons/local/no-bid";
import { quoteRevisionStatusLabel } from "@/lib/utils";
import { components } from "@/lib/ApiSchema";
import { ReactNode } from "react";

export default function RFQStatusTableCell({ rfq }: { rfq: RFQListItem }) {
  const status = rfq.status;

  if (rfq.processing) {
    return (
      <SpecialStatus
        label="Processing…"
        className="text-slate-500 bg-slate-100"
      />
    );
  }

  if (!status) return null;

  if (["new", "estimated", "quote_created", "sent_quote"].includes(status)) {
    return (
      <div className="flex gap-2 items-center">
        <Progress status={status} />
        <div className="text-xs text-nowrap">
          {quoteRevisionStatusLabel[status]}
        </div>
      </div>
    );
  }

  if (status === "sent_no_bid") {
    return (
      <SpecialStatus
        label="No Bid"
        icon={<NoBidIcon />}
        className="border-red-900 text-red-900 bg-red-50"
      />
    );
  }

  // if (status === "error") {
  //   return (
  //     <SpecialStatus
  //       label="Error"
  //       icon={alertSvg}
  //       className="border-red-500 text-red-500 bg-red-100"
  //     />
  //   );
  // }

  if (status === "external_response") {
    return (
      <SpecialStatus
        label="External Response"
        className="border-slate-500 text-slate-500 bg-slate-100"
      />
    );
  }

  return null;
}

function Progress({ status }: { status: components["schemas"]["StatusEnum"] }) {
  return (
    <div className="flex gap-1">
      <div
        className={`h-4 w-9 rounded-tl-full rounded-bl-full ${["estimated", "quote_created", "sent_quote"].includes(status) ? "bg-blue-600" : "bg-slate-200"}`}
      />
      <div
        className={`h-4 w-9 ${["quote_created", "sent_quote"].includes(status) ? "bg-blue-600" : "bg-slate-200"}`}
      />
      <div
        className={`h-4 w-9 rounded-tr-full rounded-br-full ${["sent_quote"].includes(status) ? "bg-blue-600" : "bg-slate-200"}`}
      />
    </div>
  );
}

function SpecialStatus({
  label,
  icon,
  className,
}: {
  label: string;
  icon?: ReactNode;
  className: string;
}) {
  return (
    // special width to match the Progress bar width
    <div
      className={`w-[calc(7.5rem-4px)] flex justify-center gap-2 rounded-4xl border-2 ${className} items-center`}
    >
      {icon}
      <div className="text-xs">{label}</div>
    </div>
  );
}
